import React from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from '../../util/reactIntl';
import { PrimaryButton } from '../../components';

import css from './ProjectListingPage.css';

const SectionDescriptionMaybe = props => {
  const {
    publicData,
    onContactUser,
    showContactUser,
    hasExistingProposal,
    existingProposalTransactionId,
    checkExistingProposalInProgress,
    history,
  } = props;
  const { projectProblem, descriptionText, projectIndustryExperience } = publicData || {};

  const handleViewApplication = () => {
    if (existingProposalTransactionId) {
      history.push(`/application/order/${existingProposalTransactionId}`);
    }
  };

  return (
    <div className={css.sectionDescription}>
      {projectProblem ? (
        <div>
          <h2 className={css.descriptionTitle}>
            <FormattedMessage id="ProjectListingPage.problemTitle" />
          </h2>
          <div className={css.description} dangerouslySetInnerHTML={{ __html: projectProblem }} />
        </div>
      ) : null}

      <div>
        <h2 className={css.descriptionTitle}>
          <FormattedMessage id="ProjectListingPage.descriptionTitle" />
        </h2>
        <div className={css.description} dangerouslySetInnerHTML={{ __html: descriptionText }} />
      </div>
      {projectIndustryExperience ? (
        <div>
          <h2 className={css.descriptionTitle}>
            <FormattedMessage id="ProjectListingPage.industryExperienceTitle" />
          </h2>
          <div
            className={css.description}
            dangerouslySetInnerHTML={{ __html: projectIndustryExperience }}
          />
        </div>
      ) : null}
      {!checkExistingProposalInProgress &&
        (showContactUser ? (
          <PrimaryButton rootClassName={css.contactButton} onClick={onContactUser}>
            <FormattedMessage id="ProjectListingsPage.sendApplicationButton" />
          </PrimaryButton>
        ) : hasExistingProposal ? (
          <PrimaryButton rootClassName={css.contactButton} onClick={handleViewApplication}>
            <FormattedMessage id="ProjectListingPage.viewApplicationButton" />
          </PrimaryButton>
        ) : null)}
    </div>
  );
};

export default withRouter(SectionDescriptionMaybe);
